module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAAH6ji2bAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAIxJREFUeNpi9PDwKGBgYOgH4g8MyIARWQYggECc/xjSYBGAAEJWBwMfmBiwAIAAAqncD6QdkMQ2YFXJQJl2gAAiyUiQ2/3RjEUGoFA5QJk1FFkNEEAgheuhigRwKDwAxBtJspooE2nj62FjNUCAwaLQHmqiAR6TGfBE8QUofZD6nqZVqh318qiXSfAyADLsOoUxrynMAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/icon/shuju.png
// module id = F2dJ
// module chunks = 1